/*
 *
 * PciResponsabilityModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 07-Aug-2025
 */
import React, { useEffect, useState } from 'react'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import PortalCheckBox from '@nexidigital/portalcheckbox'
import PortalLoader from '@nexidigital/portalloader'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import './PciResponsabilityModal.scss'
import { flowToastMapType } from '../../utils/flowToastMap'

const PciResponsabilityModal = (props) => {
  const unansweredQuestion = props.pciData.unanswered_question
  const checkboxOptionId = 'pci-responsability-consent'
  const [consent1, setConsent1] = useState(false)
  const [showError, setShowError] = useState(false)
  const merchantData = props.userProfile.merchant
  const companyData = props.companyData
  const userData = props.userProfile.user

  useEffect(() => {
    props.actions.doGetCompanyData()
    props.actions.doGetShops()
  }, [])

  const handleSubmit = () => {
    if (!consent1) {
      setShowError(true)
      props.actions.doShowToast(flowToastMapType.ERROR_TOAST, {
        label: formattedMessage.toastError
      })
    } else {
      const payloadToSend = {
        idSurvey: props.pciData.id_survey,
        registry: {
          partita_iva: companyData.vatNumber,
          ext_merchant_id: merchantData.id,
          dba: null,
          rag_sociale: merchantData.companyName,
          contact_name: companyData.legalRepresentative,
          phone_contact: `${userData.prefixPhone}${userData.telephoneNumber}`,
          email_contact: userData.email,
          addr_business: companyData.address.street,
          addr_city: companyData.address.location,
          addr_reg: companyData.address.province,
          addr_stato: companyData.address.country,
          addr_cap: companyData.address.postIndex,
          business_url: null,
          client_service: null
        },
        store: props.shops.map((shop) => ({
          pv_name: shop.shopName,
          pv_location: shop.address.city,
          pv_agreement: shop.address.street
        }))
      }
      unansweredQuestion
        ? props.actions.doAnswerQuestion({
          idSurvey: props.pciData.id_survey,
          idQuestion: unansweredQuestion.id_question || 220,
          ArrayOfIdAnswer: [unansweredQuestion?.answers[0]?.id_answer],
          sendQuestionnairePayload: payloadToSend
        })
        : props.actions.doSendQuestionnaire(payloadToSend)
    }
  }

  const handleCheckboxChange = (value) => {
    const isChecked = value.checked
    setConsent1(isChecked)
    if (isChecked && showError) {
      setShowError(false)
    }
  }

  return (
    <MerchantModal
      onClose={() => {
        props.actions.doHideToast()
        props.actions.doHidePopup()
      }}
      topBarTitle=' '
      primaryButtonLabel={formattedMessage.primaryButtonLabel}
      primaryAction={handleSubmit}
      primaryButtonDisabled={props.isCompanyDataLoading}
      title={formattedMessage.title}
    >
      {props.isCompanyDataLoading && props.isShopsLoading
        ? (
          <PortalLoader centered circular />
          )
        : (
          <MerchantGenericCard
            title={formattedMessage.cardTitle}
            subtitle={formattedMessage.cardSubtitle}
          >
            <PortalCheckBox
              options={[
                {
                  id: checkboxOptionId,
                  label: formattedMessage.confirmLabel,
                  checked: consent1,
                  error: showError ? formattedMessage.toastError : false
                }
              ]}
              onChange={handleCheckboxChange}
            />
          </MerchantGenericCard>
          )}
    </MerchantModal>
  )
}

PciResponsabilityModal.propTypes = {
  actions: PropTypes.object,
  pciData: PropTypes.object,
  protectionLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  userProfile: PropTypes.object,
  companyData: PropTypes.object,
  isCompanyDataLoading: PropTypes.bool,
  shops: PropTypes.array,
  isShopsLoading: PropTypes.bool
}

PciResponsabilityModal.defaultProps = {
  actions: {},
  pciData: {},
  protectionLevel: null,
  userProfile: {},
  companyData: {},
  isCompanyDataLoading: false,
  shops: [],
  isShopsLoading: false
}

export default PciResponsabilityModal
